import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './CookieConsent.css';

const CookieConsent = ({ language }) => {
  const [showBanner, setShowBanner] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowBanner(false);
  };

  const handlePrivacyPolicy = () => {
    navigate('/privacy-policy');
  };

  if (!showBanner) return null;

  const content = {
    sq: {
      title: '🍪 Përdorim Cookies',
      message: 'Ne përdorim cookies për të përmirësuar përvojën tuaj dhe për analitikë. Ju mund të refuzoni cookies jo-esenciale.',
      privacy: 'Politika e Privatësisë',
      reject: 'Refuzo',
      accept: 'Prano të Gjitha'
    },
    en: {
      title: '🍪 We Use Cookies',
      message: 'We use cookies to improve your experience and for analytics. You can reject non-essential cookies.',
      privacy: 'Privacy Policy',
      reject: 'Reject',
      accept: 'Accept All'
    }
  };

  const text = content[language] || content.sq;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <h3>{text.title}</h3>
        <p>{text.message}</p>
        <div className="cookie-consent-buttons">
          <button onClick={handlePrivacyPolicy} className="cookie-btn-link">
            {text.privacy}
          </button>
          <button onClick={handleReject} className="cookie-btn-reject">
            {text.reject}
          </button>
          <button onClick={handleAccept} className="cookie-btn-accept">
            {text.accept}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
